import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum, UsersApi, UserViewEntity } from '@shared/api';

interface UseUsersStore {
  loading: boolean;
  data: UserViewEntity[];
  error: string | null;
  getUsers: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useUsersStore = create<UseUsersStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getUsers: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await UsersApi.getUsers(signal);
      set({ loading: false, data: result || [] });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], error: null }),
}));
